module.exports = __webpack_public_path__ + "img/jackpot.55685a4a.svg";